import { render, staticRenderFns } from "./PlayerButton.vue?vue&type=template&id=5256c4ee&scoped=true&"
import script from "./PlayerButton.vue?vue&type=script&lang=js&"
export * from "./PlayerButton.vue?vue&type=script&lang=js&"
import style0 from "./PlayerButton.vue?vue&type=style&index=0&id=5256c4ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5256c4ee",
  null
  
)

export default component.exports